import styled from 'styled-components'
import { grayLight } from '@bufferapp/ui/style/colors'

/**
 *
 */

export const Placeholder = styled.div`
  width: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'width' does not exist on type 'ThemedSty... Remove this comment to see the full error message
    props.width || '100%'};
  height: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'height' does not exist on type 'ThemedSt... Remove this comment to see the full error message
    props.height || '100%'};
  margin-bottom: 6px;
  background-color: ${grayLight};
  border-radius: 2px;
`
